import { render, staticRenderFns } from "./RegisterKelengkapan.vue?vue&type=template&id=6787eb02&scoped=true&"
import script from "./RegisterKelengkapan.vue?vue&type=script&lang=js&"
export * from "./RegisterKelengkapan.vue?vue&type=script&lang=js&"
import style0 from "./RegisterKelengkapan.vue?vue&type=style&index=0&id=6787eb02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6787eb02",
  null
  
)

export default component.exports